import api from "./axios";

export const getMetrics = () => api.get("/api/metrics/");
export const getTechStack = () => api.get("/api/tech-stack/");
export const getAuditLogs = () => api.get("/api/admin/audit-logs/");

// Admin metrics
export const adminGetMetrics = () => api.get("/api/admin/metrics/");
export const adminCreateMetric = (data) => api.post("/api/admin/metrics/", data);
export const adminUpdateMetric = (id, data) => api.patch(`/api/admin/metrics/${id}/`, data);
export const adminDeleteMetric = (id) => api.delete(`/api/admin/metrics/${id}/`);
export const adminGetMetricById = (id) => api.get(`/api/admin/metrics/${id}/`);